import React, { useEffect, useState } from 'react';

import Icon, { Icons } from '../../components/Icon/Icon';
import PageHeader from '../../components/PageHeader';
import './ExportTransactions.scss';
import { appSlice } from '../../store/slices';
import { t } from '../../lang';
import { useDispatch } from 'react-redux';
import PeriodFilter from '../../components/PeriodFilter/PeriodFilter';

const periods = [
	{
		title: 'All',
		value: 'all',
	},
	{
		title: '3 Months',
		value: '3month',
	},
	{
		title: 'Month',
		value: '3month',
	},
	{
		title: 'Last 30 days',
		value: 'last30days',
	},
	{
		title: 'Week',
		value: 'week',
	},
];

const ExportTransactions = () => {
	const dispatch = useDispatch();

	const [customPeriod, setCustomPeriod] = useState();

	useEffect(() => {
		if (customPeriod) {
			dispatch(
				appSlice.actions.addModal({
					title: t('Export format'),
					tag: 'ExportTransactionsModal',
					isOpen: true,
					height: '50%',
					outsideParams: { custom: customPeriod },
				})
			);
		}
	}, [customPeriod]);

	const handleOpenPeriod = value => {
		dispatch(
			appSlice.actions.addModal({
				title: t('Export format'),
				tag: 'ExportTransactionsModal',
				isOpen: true,
				height: '50%',
				outsideParams: { period: value },
			})
		);
	};

	return (
		<div className='export-transactions'>
			<PageHeader collapsed={true} />

			<div className='export-transactions-block'>
				<div className='export-transactions-block-icon'>
					<Icon type={Icons.ARROW_SQUARE_UP} width={40} height={40} />
				</div>

				<div className='export-transactions-block-title'>
					Export transactions
				</div>
				<div className='export-transactions-block-text'>
					Export your transaction history for the selected period for reporting
					or analysis.
				</div>
			</div>

			<div className='export-transactions-periods-text'>Date range</div>
			<div className='export-transactions-periods'>
				{periods.map(item => (
					<div
						className='export-transactions-periods-item'
						onClick={() => handleOpenPeriod(item.value)}
					>
						<div className='export-transactions-periods-item-name'>
							{item.title}
						</div>
						<Icon type={Icons.ARROW_CHEVRON} height={16} />
					</div>
				))}
				<PeriodFilter onChange={setCustomPeriod} period={customPeriod}>
					<div className='export-transactions-periods-item'>
						<div className='export-transactions-periods-item-name'>Period</div>
						<div className='export-transactions-periods-item-data'>
							<div className='export-transactions-periods-item-span'>
								{new Date().toLocaleDateString('ru-RU')}
							</div>
							<Icon type={Icons.ARROW_CHEVRON} height={16} />
						</div>
					</div>
				</PeriodFilter>
			</div>
		</div>
	);
};

export default ExportTransactions;
